import styled from "styled-components";

import { StyledBaseHeader } from "@/components/layouts/styled";
import { breakpoints } from "@/styles/breakpoints";

export const StyledAuthHeader = styled(StyledBaseHeader)`
    box-sizing: border-box;
    width: 100%;
    height: 63px;
    padding: 0 1.8rem;
    color: var(--color-primary-fg);
    background-color: var(--color-primary);
    border-radius: 0 0 30px 30px;
    @media ${breakpoints.xs} {
        height: 42px;
        padding: 0 8px;
        border-radius: 0 0 15px 15px;
    }
    .auth-header-container {
        max-width: var(--max-page-width);
        height: 100%;
        margin: 0 auto;
    }
    li {
        button {
            font-size: var(--size-16);
            font-weight: var(--weight-600);
            @media ${breakpoints.xs} {
                font-size: var(--size-14);
            }
        }
    }
    .logo {
        svg {
            @media ${breakpoints.xs} {
                width: 36px;
                height: 36px;
            }
        }
    }
    .logo-separator {
        min-width: 1px;
        margin-right: 8px;
        margin-left: 8px;
        @media ${breakpoints.xs} {
            height: 36px;
            margin-right: 0;
            margin-left: 0;
        }
    }
    .header-components-action {
        max-width: 100%;
        button {
            min-width: 48px;
            padding: 6px 10px;
            height: 100%;
        }
    }
`;
